export function summarizeVersionAdoption(
  versions: readonly { appVersion: string; activeDevices: number }[],
): { appVersion: string; activeDevices: number }[] {
  const counts = new Map<string, number>();
  for (const row of versions) {
    if (row.activeDevices > 0) {
      counts.set(row.appVersion, (counts.get(row.appVersion) ?? 0) + row.activeDevices);
    }
  }
  return Array.from(counts, ([appVersion, activeDevices]) => ({ appVersion, activeDevices }))
    .sort((a, b) => b.activeDevices - a.activeDevices || a.appVersion.localeCompare(b.appVersion));
}
